import store from '../configureStore';
import { apiGet } from './apiUtil';

export const getPortalUrl = () => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiGet(`/stripe/get-portal-url?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
  });
};
